import { normalizeProfileDisplayName } from "./profileName";
import { normalizeCapsuleType } from "./timeCapsuleForward";

const FEATURED_CAPSULE_TYPES = new Set(["sponsored", "memberexclusive"]);

export function buildShareSenderName(rawName) {
  return normalizeProfileDisplayName(rawName);
}

export function getShareCopyVariant(capsuleOrWizardData = {}) {
  const forwardedFromType = normalizeCapsuleType(
    capsuleOrWizardData?.forwardedFromType
  );
  if (FEATURED_CAPSULE_TYPES.has(forwardedFromType)) return "featured";
  const capsuleType = normalizeCapsuleType(
    capsuleOrWizardData?.capsuleType || capsuleOrWizardData?.type
  );
  if (FEATURED_CAPSULE_TYPES.has(capsuleType)) return "featured";
  return "capsule";
}

export function buildCapsuleShareText({ senderName = "", variant = "capsule" } = {}) {
  const name = buildShareSenderName(senderName);
  if (variant === "featured") {
    return name
      ? `${name} shared a featured drop with you.`
      : "I shared a featured drop with you.";
  }
  return name ? `${name} sent you a time capsule.` : "I sent you a time capsule.";
}

export function buildCapsuleShareMessage({
  senderName = "",
  variant = "capsule",
  shareUrl = "",
} = {}) {
  const text = buildCapsuleShareText({ senderName, variant });
  const url = String(shareUrl || "").trim();
  return url ? `${text} ${url}` : text;
}
